import Vue from 'vue';
import Router from 'vue-router';

import MenuDefine from '@/constants/menu';
import { rootNode, treeType, TREE_TYPE_DELIMETER } from '@/constants/tree';
import WLogin from '@/views/login';
import WIpScan from '@/components/popup/IpScan';
import WMibBrowser from '@/components/popup/MibBrowser';
import WFrame from '@/views/frame';
import WDashboard from '@/views/dashboard';
import WTopologymap from '@/views/topologymap';
import WPerformance from '@/views/performance';
// import WConfig from '@/views/config';
import WChart from '@/views/chart';
import WLog from '@/views/log';
import WLogAnalysis from '@/views/log-analysis';
import WEvent from '@/views/event';
import WWork from '@/views/work';
import WReport from '@/views/report';
import WApm from '@/views/apm';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    component: WLogin,
  },
  {
    path: '/ip-scan',
    component: WIpScan,
    children: [
      {
        path: ':objId',
        component: WIpScan,
      },
    ],
  },
  {
    path: '/mib-browser',
    component: WMibBrowser,
    children: [
      {
        path: ':objId',
        component: WMibBrowser,
      },
    ],
  },
  {
    path: '/',
    component: WFrame,
    redirect: `/${MenuDefine.DASHBOARD}/${treeType.GRID_DASHBOARD}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
    children: [
      {
        path: `/${MenuDefine.DASHBOARD}`,
        component: WDashboard,
        redirect: `/${MenuDefine.DASHBOARD}/${treeType.GRID_DASHBOARD}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
        children: [
          {
            path: ':treeKey',
            component: WDashboard,
          },
        ],
      },
      {
        path: `/${MenuDefine.TOPOLOGYMAP}`,
        component: WTopologymap,
        // redirect: `/${MenuDefine.TOPOLOGYMAP}`,
        children: [
          {
            path: ':treeKey',
            component: WTopologymap,
            children: [
              {
                path: ':objId',
                component: WTopologymap,
              },
            ],
          },
        ],
      },
      {
        path: `/${MenuDefine.PERF_OPER}`,
        component: WPerformance,
        redirect: `/${MenuDefine.PERF_OPER}/${treeType.LOGICAL}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
        children: [
          {
            path: ':treeKey',
            component: WPerformance,
            children: [
              {
                path: ':activeTab',
                component: WPerformance,
              },
            ],
          },
        ],
      },
      {
        path: `/${MenuDefine.CHART}`,
        component: WChart,
      },
      {
        path: `/${MenuDefine.LOG}`,
        component: WLog,
        redirect: `/${MenuDefine.LOG}/${treeType.LOG}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
        children: [
          {
            path: ':treeKey',
            component: WLog,
            children: [
              {
                path: ':activeTab',
                component: WLog,
              },
            ],
          },
        ],
      },
      {
        path: `/${MenuDefine.LOG_ANALYSIS}`,
        component: WLogAnalysis,
        redirect: `/${MenuDefine.LOG_ANALYSIS}/${treeType.LOG}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
        children: [
          {
            path: ':treeKey',
            component: WLogAnalysis,
            children: [
              {
                path: ':activeTab',
                component: WLogAnalysis,
              },
            ],
          },
        ],
      },
      {
        path: `/${MenuDefine.EVENT}`,
        component: WEvent,
        redirect: `/${MenuDefine.EVENT}/${treeType.LOGICAL}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
        children: [
          {
            path: ':treeKey',
            component: WEvent,
            children: [
              {
                path: ':activeTab',
                component: WPerformance,
              },
            ],
          },
        ],
      },
      {
        path: `/${MenuDefine.WORK}`,
        component: WWork,
      },
      {
        path: `/${MenuDefine.REPORT}`,
        component: WReport,
        redirect: `/${MenuDefine.REPORT}/${treeType.REPORT}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`,
        children: [
          {
            path: ':treeKey',
            component: WReport,
          },
        ],
      },
      {
        path: `/${MenuDefine.APM}`,
        component: WApm,
        redirect: `/${MenuDefine.APM}/instance`,
        children: [
          {
            path: ':treeType',
            component: WApm,
            children: [
              {
                path: ':treeKey',
                component: WApm,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js